export default __webpack_public_path__ + "static/media/JasonThomas.0fc3cf48.jpg";